import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() padding: string = '15px'
  @Input() backgroundColor: string | null = '#1c3d85'; // Default color set here
  @Input() message: string = '';
}
